var React = require('react');

function Document (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_987_150364","style":{"maskType":"luminance"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"25","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 4.5V24.5H0V0.5H18V4.5H24Z","fill":"white"})),React.createElement("g",{"mask":"url(#mask0_987_150364)","key":1},[React.createElement("path",{"d":"M16 6.5H8V8.5H16V6.5Z","key":0}),React.createElement("path",{"d":"M12 10.5H16V12.5H12V10.5Z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 2.5H20V22.5H10.5858L4 15.9142V2.5ZM12 20.5H18V4.5H6V14.5H12V20.5ZM10 19.0858V16.5H7.41421L10 19.0858Z","key":2})])]);
}

Document.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Document;

Document.default = Document;
